import React from 'react';

import { useGetDashboardVerificationRequestsCountGroupedByIsManualQuery } from 'src/api';
import { OverviewTotalVerifications } from 'src/types/dashboard';

import { useDashboardCVAdminData } from './useDashboardCVAdminData';

export const useOverviewTotalVerifications = () => {
  const { date, peos, employers } = useDashboardCVAdminData();

  const { data, loading } = useGetDashboardVerificationRequestsCountGroupedByIsManualQuery({
    variables: {
      peoIds: peos?.map(peo => peo.id),
      employerIds: employers?.map(employer => employer.id),
      asOfDate: date.toISO(),
    },
  });

  const totalVerifications = React.useMemo(() => {
    const result: OverviewTotalVerifications = {
      auto: 0,
      manual: 0,
    };

    for (const group of data?.getDashboardVerificationRequestsCountGroupedByIsManual ?? []) {
      if (group.isManual) {
        result.manual += group.count;
      } else {
        result.auto += group.count;
      }
    }

    return result;
  }, [data]);

  return { totalVerifications, totalVerificationsLoading: loading };
};
